import { offsetLimitPagination } from 'utils/pagination';

const typePolicies = {
	getMediaFolder: offsetLimitPagination(["folderId"]),
	searchMedia: offsetLimitPagination(["input", ["search", "sort", "sortDesc"]]),
};

export default typePolicies;
